import { forwardRef, type Ref, type SVGProps } from "react";
const IconTreesOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M29 28h-6v-8.09A5.99 5.99 0 0 0 25.58 9.2a4.5 4.5 0 1 0-7.16 0A5.99 5.99 0 0 0 21 19.9V28H10v-3.6a5.5 5.5 0 0 0 2.12-9.93 4 4 0 1 0-6.24 0A5.5 5.5 0 0 0 8 24.4V28H3a1 1 0 0 0 0 2h26a1 1 0 0 0 0-2M18 14a3.97 3.97 0 0 1 1.61-3.2 2 2 0 0 0 .4-2.8A2.5 2.5 0 1 1 24 8a2 2 0 0 0 .4 2.8 3.98 3.98 0 0 1-1.4 7.06V13a1 1 0 0 0-2 0v4.86A4 4 0 0 1 18 14M5.5 19a3.5 3.5 0 0 1 1.52-2.88 2 2 0 0 0 .43-2.89A1.98 1.98 0 0 1 7 12a2 2 0 0 1 4 0 1.98 1.98 0 0 1-.45 1.23 2 2 0 0 0 .43 2.89 3.48 3.48 0 0 1-.98 6.22v-4.38a.96.96 0 0 0-.96-.96h-.08a.96.96 0 0 0-.96.96v4.38A3.5 3.5 0 0 1 5.5 19"
    />
  </svg>
);
const ForwardRef = forwardRef(IconTreesOutlineSVG);
ForwardRef.displayName = "IconTreesOutline";
export { ForwardRef as IconTreesOutline };
